//-----------------------------|| LIST ||---------------------------------------------------------------
export const SET_REPORT_GENERATION_LIST = 'SET_REPORT_GENERATION_LIST';
export const CLEAR_REPORT_GENERATION_LIST = 'CLEAR_REPORT_GENERATION_LIST';
export const REPORT_GENERATION_LIST_PENDING = 'REPORT_GENERATION_LIST_PENDING';
export const REPORT_GENERATION_LIST_ERROR = 'REPORT_GENERATION_LIST_ERROR';
export const REPORT_GENERATION_LIST_ERROR_CLEAR = 'REPORT_GENERATION_LIST_ERROR_CLEAR';
export const FIELDS_TABLE_DIALOG_OPEN = 'FIELDS_TABLE_DIALOG_OPEN';
export const FIELDS_TABLE_DIALOG_CLOSE = 'FIELDS_TABLE_DIALOG_CLOSE';
export const SET_CURRENT_BIRD_RECORD = 'SET_CURRENT_BIRD_RECORD';

//-----------------------------|| FILTER ||-------------------------------------------------------------
export const REPORT_FILTER_DIALOG_OPEN = 'REPORT_FILTER_DIALOG_OPEN';
export const REPORT_FILTER_DIALOG_CLOSE = 'REPORT_FILTER_DIALOG_CLOSE';
export const SET_REPORT_FILTER_DATA = 'SET_REPORT_FILTER_DATA';

//-----------------------------|| DETAILS ||------------------------------------------------------------
export const SET_REPORT_GENERATION_DETAILS = 'SET_REPORT_GENERATION_DETAILS';
export const CLEAR_REPORT_GENERATION_DETAILS = 'CLEAR_REPORT_GENERATION_DETAILS';
export const REPORT_GENERATION_DETAILS_PENDING = 'REPORT_GENERATION_DETAILS_PENDING';
export const REPORT_GENERATION_DETAILS_ERROR = 'REPORT_GENERATION_DETAILS_ERROR';
export const REPORT_GENERATION_DETAILS_ERROR_CLEAR = 'REPORT_GENERATION_DETAILS_ERROR_CLEAR';

//-----------------------------|| CREATE ||-------------------------------------------------------------
export const REPORT_GENERATION_DATA = 'REPORT_GENERATION_DATA';
export const REPORT_GENERATION_CREATE_DIALOG_OPEN = 'REPORT_GENERATION_CREATE_DIALOG_OPEN';
export const REPORT_GENERATION_CREATE_DIALOG_CLOSE = 'REPORT_GENERATION_CREATE_DIALOG_CLOSE';
export const REPORT_GENERATION_CREATE_PENDING = 'REPORT_GENERATION_CREATE_PENDING';
export const REPORT_GENERATION_CREATE_ERROR = 'REPORT_GENERATION_CREATE_ERROR';
export const REPORT_GENERATION_CREATE_ERROR_CLEAR = 'REPORT_GENERATION_CREATE_ERROR_CLEAR';

//-----------------------------|| EDIT ||---------------------------------------------------------------
export const REPORT_GENERATION_EDIT_DIALOG_OPEN = 'REPORT_GENERATION_EDIT_DIALOG_OPEN';
export const REPORT_GENERATION_EDIT_DIALOG_CLOSE = 'REPORT_GENERATION_EDIT_DIALOG_CLOSE';
export const REPORT_GENERATION_EDIT_PENDING = 'REPORT_GENERATION_EDIT_PENDING';
export const REPORT_GENERATION_EDIT_ERROR = 'REPORT_GENERATION_EDIT_ERROR';
export const REPORT_GENERATION_EDIT_ERROR_CLEAR = 'REPORT_GENERATION_EDIT_ERROR_CLEAR';

//-----------------------------|| EDIT ||---------------------------------------------------------------
export const SET_REPORT_SIDEBAR_LIST = 'SET_REPORT_SIDEBAR_LIST';